import type { TJSONSchema } from "@artifact-management/json-dynamic-form";
import { FormControlLabel, FormHelperText, Switch } from "@mui/material";
import { Controller, type FieldValues, type Path, type PathValue } from "react-hook-form";
import type { IFormGenInputProps } from "./index";

export const FormGenInputSwitch = <Schema extends TJSONSchema, T extends FieldValues>({
  control,
  uiSchemaElement,
}: IFormGenInputProps<Schema, T>) => {
  return (
    <Controller
      control={control}
      name={uiSchemaElement.scope as unknown as Path<T>}
      defaultValue={false as unknown as PathValue<T, Path<T>>}
      render={({ field, fieldState }) => (
        <>
          <FormControlLabel
            label={uiSchemaElement.label}
            labelPlacement="start"
            disabled={uiSchemaElement.disabled}
            control={<Switch checked={field.value} onChange={field.onChange} onBlur={field.onBlur} />}
          />
          {fieldState.error && <FormHelperText error>{fieldState.error.message}</FormHelperText>}
        </>
      )}
    />
  );
};
